//@flow
import React, {forwardRef} from 'react';
import {Typography, makeStyles, ButtonBase} from '@material-ui/core';
import {Delete, DragIndicator} from '@material-ui/icons';
import IosSwitch from '../../../elements/IosSwitch/IosSwitch';
import {colors} from '../../../assets/styles/colors';
import TiendadaTooltip from '../../../elements/tiendada-tooltip';

import {SortableKnob} from 'react-easy-sort';

const useStyles = makeStyles(theme => ({
  item: {
    background: colors.grey200,
    borderRadius: 12,
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingInline: theme.spacing(2),
    userSelect: 'none',
    height: 48,
    position: 'relative',
    color: colors.grey800,
  },
  deleteIcon: {
    color: colors.grey600,
  },
  label: {
    color: colors.grey800,
    fontWeight: 500,
    fontSize: 14,
    flexGrow: 1,
  },
  deleteButton: {
    color: colors.danger,
  },
  successIcon: {
    color: colors.success,
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  sectionLink: {
    flexGrow: 1,
    textDecoration: 'none',
    height: '100%',
    color: colors.grey800,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',

    '&[data-empty-section="true"]': {
      opacity: 0.5,
    },
  },
  dragIcon: {
    color: colors.grey600,
    cursor: 'grab',

    '&:active': {
      cursor: 'grabbing',
    },
  },
  switchContainer: {
    '&[data-disabled="true"]': {
      opacity: 0.5,
    },
  },
}));

type Props = {
  id: string,
  title: string,
  enabled?: boolean,
  onDelete?: (id: string) => void,
  onToggleSectionEnable: (id: string) => void,
  emptySection?: boolean,
  sectionEnabled?: boolean,

  tooltipLabel?: string,

  toggleDisabled?: boolean,
};

const LayoutSectionItem = forwardRef<Props, any>(function SectionItem(
  props: Props,
  ref
) {
  const {
    id,
    title,
    enabled,
    onDelete,
    emptySection,
    tooltipLabel,
    sectionEnabled,
    toggleDisabled,
    onToggleSectionEnable,
  } = props;
  const classes = useStyles();

  return (
    <div className={classes.item} ref={ref}>
      {enabled && (
        <SortableKnob>
          <DragIndicator className={classes.dragIcon} />
        </SortableKnob>
      )}
      <TiendadaTooltip title={tooltipLabel} placement="top" arrow>
        <a
          href={`#${id}`}
          className={classes.sectionLink}
          data-empty-section={emptySection}
        >
          <Typography className={classes.label}>{title}</Typography>
        </a>
      </TiendadaTooltip>
      <div className={classes.itemOptions}>
        {onDelete && enabled && (
          <ButtonBase
            className={classes.deleteButton}
            onClick={() => {
              onDelete(id);
            }}
          >
            <Delete />
          </ButtonBase>
        )}
        {onToggleSectionEnable && enabled && (
          <div
            className={classes.switchContainer}
            data-disabled={toggleDisabled}
          >
            <IosSwitch
              disabled={toggleDisabled}
              size="small"
              checked={!!sectionEnabled}
              onChange={() => {
                onToggleSectionEnable(id);
              }}
              classes={{root: classes.switchRoot}}
            />
          </div>
        )}
      </div>
    </div>
  );
});

export default LayoutSectionItem;
